<script setup lang="ts">
  import InputDateQC from '@qicgroupdoha/qic-connect-ds/components/InputDateQC'
  import { useI18n } from 'vue-i18n'
  import { MAX_DATE } from '@/shared/constants/dates.constants'
  import { BIRTH_MIN_DATE, BIRTH_DATE_DEFAULT_VALUE } from '../../VisitorForm.constants'

  interface Props {
    modelValue: Date | null
    errors?: string[]
    isValid: boolean
    disabled: boolean
    loading: boolean
  }

  const { locale } = useI18n()
  defineProps<Props>()
  defineEmits<{ (e: 'update:modelValue', value: Date | null): void }>()
</script>

<template>
  <div style="display: flex; flex-direction: column">
    <!-- @vue-ignore -->
    <InputDateQC
      :model-value="modelValue"
      :label="$t('qic_user_dob')"
      :min-date="BIRTH_MIN_DATE"
      :max-date="MAX_DATE"
      :errors="errors"
      :locale="locale"
      :disabled="disabled"
      :calendar-props="{ startDate: modelValue ?? BIRTH_DATE_DEFAULT_VALUE }"
      :input-props="{
        isValid,
        disabled,
        containerAttrs: { 'data-test': 'birth-date-input' },
        name: 'birthDate',
        loading,
      }"
      allow-manual-input
      data-test="birth-date-input-inner"
      @update:model-value="$emit('update:modelValue', $event)"
    />
  </div>
</template>
